import { TransitionContainer } from '@nutastic/nutastic-react-app';

export const CONSTANTS = {
    ANIMATE_BACK: TransitionContainer.DIRECTIONS.BACK,
    ANIMATE_FORWARD: TransitionContainer.DIRECTIONS.FORWARD,
    APP_TRANSITION_TIME: 1000,
    APPKEY_MUSIC: 'music',
    APPKEY_VIDEOS: 'video',
    APPKEY_ARTIST: 'artist',
    APPKEY_SERIES: 'series',
    APPKEY_SHOP: 'shop',
    APPKEY_RECENT_VIDEOS: 'recentVideos',
    APPKEY_RECENT_MUSIC: 'recentMusic',
};

export const ONE_HOUR_MILLI = 60 * 60 * 1000; //3600000

export const BANNER_SWIPER_PROPS = {
    autoplay: {
        delay: 10000,
        disableOnInteraction: false,
        pauseOnMouseEnter: false
    },
    loop: true,
    slidesPerView: 2.5,
    direction: 'horizontal',
    effect: 'slide'
};

export const COVER_SWIPER_PROPS = {
    autoplay: false,
    loop: false,
    slidesPerView: 5.25,
    direction: 'horizontal',
    effect: 'slide'
};
